import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["placeholder", "loading", "iframe"]
  static values = {
    src: String,
    loaded: { type: Boolean, default: false }
  }

  connect() {
    if (this.loadedValue) return

    this.setupObserver()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  setupObserver() {
    if (!('IntersectionObserver' in window)) {
      // Fallback: load immediately if no IntersectionObserver support
      return
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.loadedValue) {
          this.load()
          this.observer.disconnect()
        }
      })
    }, {
      rootMargin: '200px 0px', // Start loading 200px before visible
      threshold: 0
    })

    this.observer.observe(this.element)
  }

  load() {
    if (this.loadedValue) return

    // Show loading indicator
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.remove('hidden')
    }

    // Create iframe
    const iframe = document.createElement('iframe')
    iframe.src = this.srcValue
    iframe.width = '100%'
    iframe.height = '450'
    iframe.style.border = '0'
    iframe.allowFullscreen = true
    iframe.loading = 'eager'
    iframe.title = 'Localização do Complexo Vale do Cerrado - Mapa'

    iframe.onload = () => {
      this.loadedValue = true
      // Hide placeholder
      if (this.hasPlaceholderTarget) {
        this.placeholderTarget.style.display = 'none'
      }
    }

    if (this.hasIframeTarget) {
      this.iframeTarget.appendChild(iframe)
    }
  }
}
